/* ------------- Types and Action Creators ------------- */

/*
 * action types
 */
const Types = {
  MENU_REQUEST: "MENU_REQUEST",
  MENU_SUCCESS: "MENU_SUCCESS",
  MENU_ERROR: "MENU_ERROR",

  SET_LANGUAGE: "SET_LANGUAGE",
  NUM_BOOKMARKS_UPDATE: "NUM_BOOKMARKS_UPDATE",

  REFRESH_TOPICS_REQUEST: "REFRESH_TOPICS_REQUEST",
  REFRESH_TOPICS_SUCCESS: "REFRESH_TOPICS_SUCCESS",

  NOTIFICATIONS_FETCH: "APP_NOTIFICATIONS_FETCH",
  NOTIFICATIONS_SET: "APP_NOTIFICATIONS_SET",

  NOTIFICATION_READ_REQUEST: "APP_NOTIFICATION_READ_REQUEST",
  NOTIFICATION_READ_SUCCESS: "APP_NOTIFICATION_READ_SUCCESS",
  NOTIFICATIONS_READ_ALL_REQUEST: "APP_NOTIFICATIONS_READ_ALL_REQUEST",
  NOTIFICATIONS_READ_ALL_SUCCESS: "APP_NOTIFICATIONS_READ_ALL_SUCCESS",

  TRACKING_ADD: "TRACKING_ADD",
  TRACKING_ADDED: "TRACKING_ADDED",

  SET_TITLE: "SET_TITLE",
  CHANGED_TITLE: "CHANGED_TITLE"
}

/*
 * action creators
 */
const Creators = {
  request: () => {
    return {
      type: Types.MENU_REQUEST
    }
  },

  success: (
    main_menu,
    footer_menu,
    topic_menu,
    categories_menu,
    num_bookmarks,
    faq
  ) => {
    return {
      type: Types.MENU_SUCCESS,
      main_menu,
      footer_menu,
      topic_menu,
      categories_menu,
      num_bookmarks,
      faq
    }
  },

  error: error => {
    return {
      type: Types.MENU_ERROR,
      error
    }
  },

  setLanguage: lang => {
    return {
      type: Types.SET_LANGUAGE,
      lang
    }
  },

  numBookmarksUpdate: num_bookmarks => {
    return {
      type: Types.NUM_BOOKMARKS_UPDATE,
      num_bookmarks
    }
  },

  refreshTopicsRequest: () => {
    return {
      type: Types.REFRESH_TOPICS_REQUEST
    }
  },
  refreshTopicsSuccess: (main_menu, topic_menu) => {
    return {
      type: Types.REFRESH_TOPICS_SUCCESS,
      main_menu,
      topic_menu
    }
  },

  fetchNotifications: () => {
    return {
      type: Types.NOTIFICATIONS_FETCH
    }
  },
  setNotifications: (notifications, unread_count) => {
    return {
      type: Types.NOTIFICATIONS_SET,
      notifications,
      unread_count
    }
  },
  readNotificationRequest: id => {
    return {
      type: Types.NOTIFICATION_READ_REQUEST,
      id
    }
  },
  readNotificationSuccess: (readAt, id) => {
    return {
      type: Types.NOTIFICATION_READ_SUCCESS,
      readAt,
      id
    }
  },
  readNotificationsAllRequest: () => {
    return {
      type: Types.NOTIFICATIONS_READ_ALL_REQUEST
    }
  },
  readNotificationsAllSuccess: readAt => {
    return {
      type: Types.NOTIFICATIONS_READ_ALL_SUCCESS,
      readAt
    }
  },

  trackingAdd: (data, tag = "_mtm") => {
    return {
      type: Types.TRACKING_ADD,
      data,
      tag
    }
  },
  trackingAdded: (data, tag) => {
    return {
      type: Types.TRACKING_ADDED,
      data,
      tag
    }
  },

  setTitle: title => {
    return {
      type: Types.SET_TITLE,
      title
    }
  },
  changedTitle: title => {
    return {
      type: Types.CHANGED_TITLE,
      title
    }
  }
}

export const AppCreators = Creators
export const AppTypes = Types

/* ------------- Initial State ------------- */
const initialState = () => {
  return {
    main_menu: {children: []},
    footer_menu: {children: []},
    topic_menu: [],
    categories_menu: [],
    faq: [],
    lang: "",
    num_bookmarks: null,
    notifications: [],
    unread_notifications_count: 0,
    error: null,
    fetching: false
  }
}

/* ------------- Reducers ------------- */
const request = state => {
  return {...state, fetching: true}
}

const success = (
  state,
  {main_menu, footer_menu, topic_menu, categories_menu, num_bookmarks, faq}
) => {
  return {
    ...state,
    fetching: false,
    main_menu: main_menu,
    footer_menu: footer_menu,
    topic_menu: topic_menu,
    categories_menu: categories_menu,
    num_bookmarks,
    faq
  }
}

const error = (state, {error}) => {
  return {...state, fetching: false, error}
}

const setLanguage = (state, {lang}) => {
  return {...state, lang}
}

const numBookmarksUpdate = (state, {num_bookmarks}) => {
  return {...state, num_bookmarks}
}

const refreshTopicsRequest = state => {
  return {...state, fetching: true}
}
const refreshTopicsSuccess = (state, {main_menu, topic_menu}) => {
  return {...state, main_menu, topic_menu}
}

const setNotifications = (state, {notifications, unread_count}) => {
  return {...state, notifications, unread_notifications_count: unread_count}
}
const readNotificationSuccess = (state, {readAt, id}) => {
  return {
    ...state,
    notifications: state.notifications.map(notification => {
      if (notification.id === id.toString()) {
        notification.read_at = readAt
      }

      return notification
    }),
    unread_notifications_count: state.unread_notifications_count - 1
  }
}
const readNotificationsAllSuccess = (state, {readAt}) => {
  return {
    ...state,
    notifications: state.notifications.map(notification => {
      if (!notification.read_at) {
        notification.read_at = readAt
      }

      return notification
    }),
    unread_notifications_count: 0
  }
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = (state, action) => {
  if (typeof state === "undefined") {
    return initialState()
  }

  switch (action.type) {
    case Types.MENU_REQUEST:
      return request(state, action)

    case Types.MENU_SUCCESS:
      return success(state, action)

    case Types.MENU_ERROR:
      return error(state, action)

    case Types.SET_LANGUAGE:
      return setLanguage(state, action)

    case Types.NUM_BOOKMARKS_UPDATE:
      return numBookmarksUpdate(state, action)

    case Types.REFRESH_TOPICS_REQUEST:
      return refreshTopicsRequest(state, action)
    case Types.REFRESH_TOPICS_SUCCESS:
      return refreshTopicsSuccess(state, action)

    case Types.NOTIFICATIONS_SET:
      return setNotifications(state, action)
    case Types.NOTIFICATION_READ_SUCCESS:
      return readNotificationSuccess(state, action)
    case Types.NOTIFICATIONS_READ_ALL_SUCCESS:
      return readNotificationsAllSuccess(state, action)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/App/redux.js